import styled from 'styled-components';

import Section from '../../../../../../../section.styles';

export const Wrapper = styled(Section)`
  padding: 0 12px var(--gap);
`;

export const Heading = styled.h2`
  margin-bottom: var(--gap);
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Text = styled.p`
  margin: 0;
`;
